import React from 'react'
import { twMerge } from 'tailwind-merge'
import { projects } from '../../data/worklog';
import useComments from '../../hooks/modals/useComments';


const Reactions = ({ type, project }) => {

  const {/* isOpen,  */onOpen/* , onClose */} = useComments();

  const t = (project) => ({
    likes: {
      label: "likes", onClick: () => { },
      value: 3, icon: "ri-heart-line"
    },
    comments: {
      label: "comments", onClick: () => onOpen(project), icon: "ri-chat-1-line",
      value: projects.find(pr => pr.client === project)?.metadata?.reviews?.length
    },
  });

  // REACTIONS ARRAY
  const reactions = [];
  const r = t(project);
  if (type.includes(r.likes.label)) {
    reactions.push(
      r.likes,
    )
  };
  if (type.includes(r.comments.label)) {
    reactions.push(
      r.comments,
    )
  }

  // console.log(reactions)

  return (
    <div id={project || "reactions & reviews"} key={project} className='paddingY relative flex items-center justify-evenly'>
      {reactions.map((reaction, i) => {
        return <ReactionItem key={reaction.label + i} {...reaction} />
      })}
    </div>
  )
}

const ReactionItem = ({ label, icon, value, onClick, className }) => {

  return (
    <button onClick={onClick} className={twMerge('relative flex flex-col min-w-[10ch] group space-y-4 center', className)}>
      <span className='iconContainer overflow-visible bg-transparent size-12 group-hover:bg-black quick'>
        <i className={` ri-xl ${icon}`} />
        <span className='bg-blakk== bg-slate-100 text-blakk absolute size-6 text-center text-base flex center -top-3 -right-3 rounded-lg'>{value}</span>
      </span>
      <span className='capitalize muted group-hover:unmute quick'>{label}</span>
    </button>
  )
}
export default Reactions